import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _Fax_instances, _Fax_baseUrlThunk;
class Fax extends SDKResource {
    constructor(config) {
        super(config);
        _Fax_instances.add(this);
    }
    /**
     * Offboard a fax number. Oystehr's [offboard](https://docs.oystehr.com/oystehr/services/fax/number/) feature makes it easy to stop using the fax service and release the project's assigned fax number with a single API call. Please note there is no way to guarantee getting the same number back again, so if you think this can break your project in any way we recommend not offboarding and avoid sending faxes until you're sure.
     *
     * Access Policy Requirements:
     * Action: `Fax:Offboard`
     * Access Policy Resource: `Fax:Number`
     */
    offboard(request) {
        return this.request('/offboard', 'post', __classPrivateFieldGet(this, _Fax_instances, "m", _Fax_baseUrlThunk).bind(this))(request);
    }
    /**
     * Onboard a fax number. Oystehr's [onboard](https://docs.oystehr.com/oystehr/services/fax/number/) feature makes it easy to start using the fax service and purchase a new fax number for your project with a single API call.
     *
     * Access Policy Requirements:
     * Action: `Fax:Onboard`
     * Access Policy Resource: `Fax:Number`
     */
    onboard(request) {
        return this.request('/onboard', 'post', __classPrivateFieldGet(this, _Fax_instances, "m", _Fax_baseUrlThunk).bind(this))(request);
    }
    /**
     * Send a fax. Oystehr's [fax sending](https://docs.oystehr.com/oystehr/services/fax/send/) feature makes it easy to send a fax to a chosen recipient with a single API call. You can use this feature to send referrals, medical records, prescriptions, and other documents that require fax transmission e.g. for HIPAA compliance.
     *
     * Access Policy Requirements:
     * Action: `Fax:Send`
     * Access Policy Resource: `Fax:Fax`
     */
    send(params, request) {
        return this.request('/send', 'post', __classPrivateFieldGet(this, _Fax_instances, "m", _Fax_baseUrlThunk).bind(this))(params, request);
    }
}
_Fax_instances = new WeakSet(), _Fax_baseUrlThunk = function _Fax_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['faxApiUrl']) !== null && _b !== void 0 ? _b : 'https://fax-api.zapehr.com/v1';
};

export { Fax };
//# sourceMappingURL=fax.js.map
